/**
 * WordPress dependencies
 * @wordpress/i18n for translation functions
 * - https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 * - Should basically always be used for any text that is visible to the user
 *
 * @wordpress/element for React components
 * - https://developer.wordpress.org/block-editor/reference-guides/packages/packages-element/
 */
import { __ } from '@wordpress/i18n';
import { decodeEntities } from '@wordpress/html-entities';

import CourseListItemSeats from './CourseListItemSeats';
import CourseListItemDate from './CourseListItemDate';
import CourseListItemStatus from './CourseListItemStatus';
import CourseListItemCategory from './CourseListItemCategory';
import CourseListItemVenue from './CourseListItemVenue';
import CourseListItemButtons from './CourseListItemButtons';
import CourseListItemClosingSoon from './CourseListItemClosingSoon';

/**
 * CourseListItem Component
 * @param {Object} props
 * @returns {JSX.Element}
 */
function CourseListItem({ props }) {
	const {
		id,
		title,
		image,
		description,
		start_date,
		end_date,
		status,
		venues,
		categories,
		url,
		registration_url,
		stock,
	} = props;

	return (
		<li className="course-list__item">
			<div className="course-list__item__image">
				<img
					src={image.url}
					alt={image.alt}
					width={image.width}
					height={image.height}
				/>
			</div>
			<div className="course-list__item__content">
				<h3 className="course-list__item__content-heading">
					{decodeEntities(title)}
				</h3>
				<div className="course-list__item__content-meta">
					<CourseListItemSeats stock={stock} />
					<CourseListItemClosingSoon start={start_date} />
				</div>
				<CourseListItemDate start={start_date} end={end_date} />
				<CourseListItemVenue venues={venues} />
				<CourseListItemCategory categories={categories} />
				<p className="course-list__item__content-description">
					{decodeEntities(description)}
				</p>
				<CourseListItemStatus status={status} />
				<CourseListItemButtons
					id={id}
					url={url}
					registrationUrl={registration_url}
					status={status}
					venues={venues}
				/>
			</div>
		</li>
	);
}

export default CourseListItem;
